import { COMPANIES } from "./types";
export const addCompanies = (value: any) => {
    return (dispatch: any) => dispatch({
        type: COMPANIES,
        payload: value
    })
}